/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import '../content-block/index';
import './content-block-simple';
import '../image/image';
import '../cta/card-cta';
import '../cta/card-cta-footer';
